import React, { useState } from 'react';
import './index.css';

const CORRECT_PIN = '1702';

function ProtectedRoute({ children }) {
  const [pin, setPin] = useState('');
  const [error, setError] = useState('');
  const [isVerified, setIsVerified] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (pin === CORRECT_PIN) {
      setIsVerified(true);
      setError('');
    } else {
      setError('PIN non corretto. Riprova.');
      setPin('');
    }
  };

  const handlePinChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // Only digits
    if (value.length <= 4) {
      setPin(value);
      setError('');
    }
  };

  if (!isVerified) {
    return (
      <>
        <div 
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundImage: `url(${process.env.PUBLIC_URL}/sfondo.jpg)`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            zIndex: -1
          }}
        />
        <div className="app-container">
          <div className="form-card" style={{ maxWidth: '400px' }}>
            <div className="form-header">
              <img 
                src={`${process.env.PUBLIC_URL}/logoTabata.png`} 
                alt="Tabata" 
                className="logo-tabata"
              />
              <h2 className="h4 mb-0 mt-3">🔒 Area Protetta</h2>
              <p className="mb-0 mt-2">Inserisci il PIN per accedere</p>
            </div>
            
            <div className="form-body">
              <form onSubmit={handleSubmit}>
                <div className="mb-4">
                  <label htmlFor="pin" className="form-label text-center w-100">
                    PIN (4 cifre)
                  </label>
                  <input
                    type="password"
                    className={`form-control form-control-lg text-center ${error ? 'is-invalid' : ''}`}
                    id="pin"
                    value={pin}
                    onChange={handlePinChange}
                    placeholder="••••"
                    maxLength="4"
                    autoFocus
                    style={{
                      fontSize: '2rem',
                      letterSpacing: '1rem',
                      fontWeight: 'bold'
                    }}
                  />
                  {error && (
                    <div className="invalid-feedback text-center">
                      {error}
                    </div>
                  )}
                </div>

                <button
                  type="submit"
                  className="btn btn-primary btn-submit w-100"
                  disabled={pin.length !== 4}
                >
                  Accedi
                </button>

                <div className="text-center mt-3">
                  <a href="/" className="text-decoration-none">
                    ← Torna alla home
                  </a>
                </div>
              </form>
            </div>
          </div>
        </div>
      </>
    );
  }

  return children;
}

export default ProtectedRoute;
